<template>
  <router-view></router-view>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  computed: {
    ...mapState("auth", ["logout"]),
  },
  methods: {
    ...mapActions("auth", ["ActionSetLogout"]),
  },
  watch: {
    logout: function () {
      if (this.logout) {
        this.ActionSetLogout(true);
        this.$router.push({ name: "login" });
      }
    },
  },
};
</script>
